import { clients } from '../../lib/clients'
import { atom, useAtom } from 'jotai'

type Device = Awaited<
  ReturnType<(typeof clients)['/api/actcastDeviceGroups/:groupId/devices']['GET']['client']>
>['body']['actcastDevices'][number]

type DeviceState = {
  loading: boolean
  devices: {
    [key: string]: Device
  }
}

export const deviceState = atom<DeviceState>({
  loading: false,
  devices: {}
})

export const useFetchDevicesFromGroupsBase = () => {
  const [devices, setDevices] = useAtom(deviceState)

  const fetchDevicesFromGroupsBase = async (options: { actcastDeviceGroupId: string; accessToken: string }) => {
    if (!options.actcastDeviceGroupId) {
      return
    }
    setDevices({ ...devices, loading: true })
    try {
      if (!options.accessToken) {
        return
      }
      const res = await clients['/api/actcastDeviceGroups/:groupId/devices'].GET.client({
        headers: {
          Authorization: `Bearer ${options.accessToken}`
        },
        params: {
          groupId: options.actcastDeviceGroupId
        }
      })
      const newDevices = { ...devices.devices }
      for (const device of res.body.actcastDevices) {
        newDevices[device._id] = device
      }
      setDevices({ ...devices, loading: false, devices: newDevices })
      return { data: res.body }
    } catch (e) {
      setDevices({ ...devices, loading: false })
    }
  }

  return { devices, fetchDevicesFromGroupsBase }
}
